module.exports = __webpack_public_path__ + "static/media/truck-ramp.14c6ae84.svg";